
import { defineComponent, PropType, toRefs } from 'vue';
import { Material } from '@/types/app';
import AppTable from '@/components/tables/base/AppTable.vue';
import Timestamp from '@/components/tables/TimestampCell.vue';
import { useTableSorting } from '@/utils';
import MaterialIcon from '@/components/MaterialIcon.vue';

export default defineComponent({
  name: 'MaterialsTable',
  components: {
    AppTable,
    Timestamp,
    MaterialIcon
  },
  props: {
    materials: {
      type: Array as PropType<Array<Material>>,
      default: () => []
    }
  },
  setup(props) {
    const { materials } = toRefs(props);
    const { sortedData: sortedMaterials, sortBy, getSortState } = useTableSorting(materials, 'name');

    return {
      sortedMaterials,
      sortBy,
      getSortState
    };
  }
});
